var _defs, _path, _path2, _path3, _script;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKnowyLogoAnimation = function SvgKnowyLogoAnimation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eZ7vfTdlJsO1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1190.6 841.9",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eZ7vfTdlJsO2-fill",
    x1: 511.5487,
    y1: 280.0528,
    x2: 679.4513,
    y2: 280.0528,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO2-fill-0",
    offset: "10.02%",
    stopColor: "#a84098"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO2-fill-1",
    offset: "13.34%",
    stopColor: "#a34b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO2-fill-2",
    offset: "29.87%",
    stopColor: "#8c6ea9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO2-fill-3",
    offset: "46.02%",
    stopColor: "#7483b5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO2-fill-4",
    offset: "61.45%",
    stopColor: "#5993bf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO2-fill-5",
    offset: "75.97%",
    stopColor: "#3b9ec5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO2-fill-6",
    offset: "89.2%",
    stopColor: "#19a4c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO2-fill-7",
    offset: "100%",
    stopColor: "#00a6ca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eZ7vfTdlJsO3-fill",
    x1: 510.7851,
    y1: 561.8185,
    x2: 680.215,
    y2: 561.8185,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO3-fill-0",
    offset: "10.02%",
    stopColor: "#00a6ca"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO3-fill-1",
    offset: "24.81%",
    stopColor: "#63b2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO3-fill-2",
    offset: "41.99%",
    stopColor: "#92c0db"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO3-fill-3",
    offset: "58.57%",
    stopColor: "#b5cde3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO3-fill-4",
    offset: "74.16%",
    stopColor: "#cdd6e9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO3-fill-5",
    offset: "88.39%",
    stopColor: "#dbdcee"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO3-fill-6",
    offset: "100%",
    stopColor: "#e0def0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eZ7vfTdlJsO4-fill",
    x1: 509.1712,
    y1: 428.6776,
    x2: 667.2243,
    y2: 428.6776,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO4-fill-0",
    offset: "10.02%",
    stopColor: "#264fa2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO4-fill-1",
    offset: "18.92%",
    stopColor: "#464da0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO4-fill-2",
    offset: "37.44%",
    stopColor: "#6e4a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO4-fill-3",
    offset: "55.32%",
    stopColor: "#88469b"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO4-fill-4",
    offset: "72.14%",
    stopColor: "#9a4399"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO4-fill-5",
    offset: "87.48%",
    stopColor: "#a44198"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eZ7vfTdlJsO4-fill-6",
    offset: "100%",
    stopColor: "#a84098"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eZ7vfTdlJsO2",
    d: "M598.9,222.6l77.9,53.2c3.6,2.4,3.5,7.7-.1,10.1l-77.9,51.6c-2,1.3-4.7,1.3-6.7,0l-77.9-51.6c-3.6-2.4-3.6-7.6-.1-10.1L592,222.6c2.1-1.4,4.9-1.4,6.9,0Z",
    transform: "matrix(3.863451 0 0 3.863451-1703.582021-809.207038)",
    opacity: 0.5,
    fill: "url(#eZ7vfTdlJsO2-fill)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "eZ7vfTdlJsO3",
    d: "M598.4,504L678,558.4c3,2,3,6.5-.1,8.5l-79.6,52.8c-1.7,1.1-3.9,1.1-5.6,0l-79.6-52.8c-3-2-3.1-6.4-.1-8.5L592.6,504c1.8-1.2,4-1.2,5.8,0Z",
    transform: "matrix(3.863451 0 0 3.863451-1703.773558-1602.209688)",
    opacity: 0.5,
    fill: "url(#eZ7vfTdlJsO3-fill)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "eZ7vfTdlJsO4",
    d: "M598.4,370.9L678,425.3c3,2,3,6.5-.1,8.5l-79.6,52.8c-1.7,1.1-3.9,1.1-5.6,0l-79.6-52.8c-3-2-3.1-6.4-.1-8.5l79.6-54.4c1.8-1.2,4-1.2,5.8,0Z",
    transform: "matrix(3.863451 0 0 3.863451-1703.773558-1236.326341)",
    opacity: 0.5,
    fill: "url(#eZ7vfTdlJsO4-fill)"
  })), _script || (_script = /*#__PURE__*/React.createElement("script", null)));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKnowyLogoAnimation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/knowy-logo-animation.fcbb267a64ecdc1736e463ac1e62fe52.svg";